import React from "react";
import {
  Datagrid,
  EditButton,
  List,
  Loading,
  TextField,
  useMutation,
  useRedirect,
  FilterButton,
  FilterForm,
  TopToolbar,
  TextInput,
} from "react-admin";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CustomExportButton, CustomImportButton } from "../../Signet/util";

const NetsuiteInlayResources = "netsuite/inlay";

const useStyles = makeStyles({
  container: {
    width: "100%",
    padding: 0,
  },
});

const InlayFilters = [
  <TextInput source="name" label="Name" defaultValue="" />,
  <TextInput source="sku_code" label="Sku Code" defaultValue="" />,
  <TextInput source="netsuite_id" label="Netsuite ID" defaultValue="" />,
  <TextInput source="netsuite_inlay_type" label="Netsuite Inlay Type" defaultValue="" />,
  <TextInput source="netsuite_inlay_group" label="Netsuite Inlay Group" defaultValue="" />,
];

const InlayListActions = (props) => {
  const classes = useStyles();
  return (
    <TopToolbar className={classes.container}>
      <Box
        display={"flex"}
        alignItems={"flex-end"}
        justifyContent="space-between"
        width={"100%"}
        sx={{ paddingBottom: "14px" }}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent="space-between"
        >
          <FilterForm filters={InlayFilters} />
        </Box>
        <Box display={"flex"} justifyItems={"flex-end"} sx={{ gap: "20px" }}>
          <CustomImportButton resource={NetsuiteInlayResources} />
          <CustomExportButton resource={NetsuiteInlayResources} />
          <FilterButton filters={InlayFilters} />
        </Box>
      </Box>
    </TopToolbar>
  );
};

const CustomEdit = ({ record }) => {
  const redirect = useRedirect();
  const inlayId = record.inlay_id || record.id;
  const [getDetails] = useMutation({
    type: "getOne",
    resource: NetsuiteInlayResources,
    payload: { id: inlayId },
  });

  const handleEdit = async (e) => {
    e.preventDefault();
    getDetails();
    redirect(`/${NetsuiteInlayResources}/${inlayId}`);
  };

  return <EditButton onClick={handleEdit} />;
};

const InlayList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;
  return (
    <List {...props} exporter={false} actions={<InlayListActions />}>
      <Datagrid rowClick={null}>
        <TextField source="name" label="Name" sortable={false} />
        <TextField source="sku_code" sortable={false} label="Sku Code" />
        <TextField source="netsuite_id" sortable={false} label="Netsuite ID" />
        <TextField
          source="netsuite_inlay_type"
          sortable={false}
          label="Netsuite Inlay Type"
        />
        <TextField
          source="netsuite_inlay_group"
          sortable={false}
          label="Netsuite Inlay Group"
        />
        <CustomEdit />
      </Datagrid>
    </List>
  );
};

export default InlayList;
